module.exports = __webpack_public_path__ + "img/white.7b3777c6.svg";